import { defineStore } from "pinia";

export const useMedicalAppointmentStore = defineStore('medicalAppointment', {
    state: () => ({
        medicalAppointment: {},
        medicalAppointments: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setMedicalAppointment(medicalAppointment) {
            this.medicalAppointment = medicalAppointment
        },
        setMedicalAppointments(medicalAppointments) {
            this.medicalAppointments = medicalAppointments
        },
        addMedicalAppointment(medicalAppointment) {
            this.medicalAppointments.unshift(medicalAppointment)
        },
        updateMedicalAppointment(medicalAppointment) {
            let index = this.medicalAppointments.findIndex(cl => cl.id === medicalAppointment.id)
            this.medicalAppointments.splice(index, 1, medicalAppointment)
        },
        deleteMedicalAppointment(medicalAppointment) {
            let index = this.medicalAppointments.findIndex(cl => cl.id === medicalAppointment.id)
            this.medicalAppointments.splice(index, 1)
        },
    },
});